import React from 'react'

import './styles.scss'

const Landing = (props) => {
  return (
    <div className='container mt-5'>
      <div className='row'>
        <div className='col-12 offset-sm-1 col-sm-10'>
          <div className='card shadow-sm border-0'>
            <div className='card-body'>{props.children}</div>
          </div>
        </div>
      </div>

      <div className='text-center mt-4'>
        AxS Health <small>v{process.env.REACT_APP_VERSION}</small>
      </div>
    </div>
  )
}

export default Landing
